<template>
    <ValidationObserver ref="obs" v-slot="{ invalid }">
        <v-row>
            <v-col cols="12" md="12" class="d-flex flex-column align-center justify-center">
                <div>
                    <iframe :width="width" :height="height" src="https://www.youtube.com/embed/07Z4YSPRstU"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                    <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                        <v-checkbox v-model="checkbox" :error-messages="v.errors[0]" input-value="false" value>
                            <template v-slot:label>
                                <div :class="(checkbox) ? `font-weight-medium primary--text` : `dark--text font-weight`">
                                    He visto el video.
                                </div>
                            </template>
                        </v-checkbox>
                    </ValidationProvider>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-spacer></v-spacer>
            <v-btn outlined @click="guardar" :disabled="invalid" class="pa-5 ma-1" color="primary">
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>guardar
            </v-btn>
        </v-row>
    </ValidationObserver>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            //data select
            checkbox: '',
            width: 420,
            height: 236.25,
        }
    },
    computed: {

    },
    methods: {
        guardar() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.$emit('isCorrectForm', { valid: true, index: this.index })
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            })
        }

    },
    props: { index: Number }
}

</script>